(() => {
  if (!document.body.classList.contains("template-collection")) return;

  const root = document.documentElement;
  let frame = null;
  let observer = null;

  const updateOffset = () => {
    frame = null;
    const header = document.querySelector("#SiteHeader");
    const toolbar = document.querySelector(".template-collection .collection-filter");

    if (!header) {
      root.style.removeProperty("--pm-collection-sticky-top");
      if (toolbar) toolbar.classList.remove("is-stuck");
      return;
    }

    const headerBottom = Math.max(0, Math.floor(header.getBoundingClientRect().bottom) - 1);
    root.style.setProperty("--pm-collection-sticky-top", `${headerBottom}px`);

    if (toolbar) {
      const toolbarTop = Math.round(toolbar.getBoundingClientRect().top);
      toolbar.classList.toggle("is-stuck", window.scrollY > 0 && toolbarTop <= headerBottom + 1);
    }
  };

  const scheduleUpdate = () => {
    if (frame === null) frame = window.requestAnimationFrame(updateOffset);
  };

  const observeHeader = () => {
    const header = document.querySelector(".header-sticky-wrapper") || document.querySelector("#SiteHeader");
    if (header && "ResizeObserver" in window) {
      observer = new ResizeObserver(scheduleUpdate);
      observer.observe(header);
    }
  };

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate, { passive: true });
  document.addEventListener("shopify:section:load", scheduleUpdate);
  observeHeader();
  scheduleUpdate();
})();

(() => {
  if (!document.body.classList.contains('template-collection')) return;

  const palette = [
    [/ירוק[-\s]?פיסטוק|פיסטוק|pistachio/i, '#A8B58D'],
    [/ורוד[-\s]?רוז|pink rose|rose pink/i, '#C98291'],
    [/כחול[-\s]?עתיק|antique blue/i, '#718892'],
    [/ורוד[-\s]?פודרה|פודרה|dusty pink/i, '#D7A7A8'],
    [/ירוק[-\s]?זית|זית|olive/i, '#7B8061'],
    [/כחול[-\s]?בהיר|light blue/i, '#A8D4E6'],
    [/רוז[-\s]?גולד|rose gold/i, '#B98276'],
    [/שמפניה|champagne/i, '#D8C3A5'],
    [/ברונזה|bronze/i, '#9B6A43'],
    [/נחושת|copper/i, '#B8734D'],
    [/בורדו|burgundy|maroon/i, '#7E3744'],
    [/חרדל|mustard/i, '#C49A3A'],
    [/אפרסק|peach/i, '#E7B08E'],
    [/מנטה|mint/i, '#AFD4C1'],
    [/פוקסיה|fuchsia|magenta/i, '#C64F83'],
    [/קאמל|camel/i, '#B8895B'],
    [/לבן|white/i, '#F7F5EF'],
    [/שמנת|קרם|cream|ivory/i, '#EFE3CB'],
    [/שחור|black/i, '#22201E'],
    [/אפור|grey|gray/i, '#9A9690'],
    [/כסף|silver/i, '#BFC1C3'],
    [/זהב|gold/i, '#C4A15D'],
    [/ורוד|pink/i, '#E8A8B8'],
    [/תכלת/i, '#9FD7E5'],
    [/טורקיז|turquoise|aqua/i, '#62B8B5'],
    [/כחול|blue/i, '#5E7FA7'],
    [/ירוק|green/i, '#789276'],
    [/חום|brown/i, '#8B654C'],
    [/בז['׳]?|beige/i, '#CEB99E'],
    [/אבן|stone/i, '#C9BDAE'],
    [/לילך|lilac/i, '#C4ADD0'],
    [/סגול|purple/i, '#8C6C9C'],
    [/אדום|red/i, '#B75C58'],
    [/כתום|orange/i, '#D58A4E'],
    [/צהוב|yellow/i, '#D8BC67'],
    [/טבעי|natural/i, '#C8AF8B'],
    [/שקוף|clear|transparent/i, '#F3F0EA']
  ];

  const getValue = (swatch) => {
    const hidden = swatch.querySelector('.visually-hidden');
    if (hidden && hidden.textContent && hidden.textContent.trim()) {
      return hidden.textContent.trim();
    }

    const label = swatch.getAttribute('aria-label') || '';
    return label.split(' - ').pop().trim();
  };

  const getCards = (scope = document) => {
    const cards = [];

    if (scope.nodeType === 1 && scope.classList.contains('grid-product')) {
      cards.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('.grid-product').forEach((card) => cards.push(card));
    }

    return cards;
  };

  const placeSwatchesInsideCards = (scope = document) => {
    getCards(scope).forEach((card) => {
      const wrapper = card.querySelector('.grid__item-image-wrapper');
      if (!wrapper) return;

      Array.from(card.children).forEach((child) => {
        if (child.classList && child.classList.contains('grid-product__colors')) {
          wrapper.appendChild(child);
        }
      });
    });
  };

  const paintSwatchesByName = (scope = document) => {
    scope.querySelectorAll('.grid-product__colors .color-swatch').forEach((swatch) => {
      const value = getValue(swatch);
      const match = palette.find(([pattern]) => pattern.test(value));
      const color = match ? match[1] : '#D8CEC3';

      swatch.removeAttribute('data-variant-image');
      swatch.classList.remove('color-swatch--with-image');
      swatch.style.setProperty('background-image', 'none', 'important');
      swatch.style.setProperty('background-color', color, 'important');
      swatch.style.setProperty('background-position', 'center', 'important');
      swatch.style.setProperty('background-size', 'cover', 'important');
      swatch.style.setProperty('background-repeat', 'no-repeat', 'important');
    });
  };

  const enhanceCollectionCards = (scope = document) => {
    placeSwatchesInsideCards(scope);
    paintSwatchesByName(document);
  };

  let frame = null;
  const scheduleEnhancement = (scope = document) => {
    if (frame !== null) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => {
      frame = null;
      enhanceCollectionCards(scope);
    });
  };

  document.addEventListener('DOMContentLoaded', () => scheduleEnhancement(document));
  document.addEventListener('shopify:section:load', (event) => scheduleEnhancement(event.target));

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) {
      scheduleEnhancement(document);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  scheduleEnhancement(document);
})();

/* Mobile menu: every item with children opens them on first tap; second tap navigates to the parent page. */
(() => {
  if (window.pampasMobileParentMenuTwoStep) return;
  window.pampasMobileParentMenuTwoStep = true;

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  const setup = () => {
    if (!isMobile()) return;

    document.querySelectorAll('#NavDrawer .mobile-nav__has-sublist').forEach((row) => {
      const parentLink = Array.from(row.children).find((el) =>
        el.matches && el.matches('a.mobile-nav__link, a.mobile-nav__link--top-level')
      );
      const toggleWrap = Array.from(row.children).find((el) =>
        el.classList && el.classList.contains('mobile-nav__toggle')
      );
      const toggle = toggleWrap && toggleWrap.querySelector('button.collapsible-trigger');
      if (!parentLink || !toggle) return;
      if (parentLink.dataset.pampasTwoStepMenu === '1') return;

      parentLink.dataset.pampasTwoStepMenu = '1';
      parentLink.setAttribute('aria-haspopup', 'true');
      const controls = toggle.getAttribute('aria-controls');
      if (controls) parentLink.setAttribute('aria-controls', controls);

      parentLink.addEventListener('click', (event) => {
        if (!isMobile()) return;

        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        if (expanded) return;

        event.preventDefault();
        event.stopPropagation();
        toggle.click();
      });
    });
  };

  let frame = null;
  const schedule = () => {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = null;
      setup();
    });
  };

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  setup();
})();

/* PAMPAS_PERSONALIZATION_CHARGE_GUARD_20260910 */
(() => {
  if (window.pampasPersonalizationChargeGuard) return;
  window.pampasPersonalizationChargeGuard = true;

  const productFormFor = (node) => {
    const section = node && node.closest ? node.closest('.product-section') : null;
    return (section && section.querySelector('form[action*="/cart/add"]')) ||
      (node && node.closest ? node.closest('form[action*="/cart/add"]') : null);
  };

  const clearStaleStickerDesign = (checkbox) => {
    const form = productFormFor(checkbox);
    if (!form || form.dataset.pmPrintMode !== 'sticker') return;

    form.querySelectorAll('[data-pm-print],[data-ded]').forEach((node) => node.remove());
    delete form.dataset.pmPrintReady;
    delete form.dataset.pmPrintMode;

    const section = form.closest('.product-section');
    const approved = section && section.querySelector('#pmApprovedMsg');
    if (approved) approved.style.display = 'none';
  };

  document.addEventListener('change', (event) => {
    const checkbox = event.target && event.target.closest
      ? event.target.closest('input[data-addon-variant][data-personalization-mode="sticker"]')
      : null;
    if (!checkbox || checkbox.checked) return;
    clearStaleStickerDesign(checkbox);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target && event.target.closest
      ? event.target.closest('form[action*="/cart/add"]')
      : null;
    if (!form || form.dataset.pmNative === '1' || form.dataset.pmPrintMode !== 'sticker') return;

    const hasStickerPrint = !!form.querySelector('[data-pm-print][type="file"]:not([data-pm-unit-print])');
    if (!hasStickerPrint) return;

    const section = form.closest('.product-section');
    const checkbox = section && section.querySelector(
      '.pampas-addons input[data-addon-variant][data-personalization-mode="sticker"]'
    );

    if (!checkbox) {
      event.preventDefault();
      event.stopImmediatePropagation();
      alert('לא ניתן להוסיף מדבקה אישית ללא תוספת המדבקה. יש לבחור את המדבקה מחדש.');
      return;
    }

    /* Fail-safe: a saved sticker design can never continue without its paid add-on. */
    checkbox.checked = true;
  }, true);
})();
